
import {defineComponent} from "vue";
import {ProductFilterOverviewRestDto} from "@/api/pharma-cpc-mgmt/models";
import CatalogBuildStatus from "@/components/layouts/catalog/CatalogBuildStatus.vue";
import BaseTitle from "@/components/UI/BaseTitle.vue";
import {AbilityContext} from "@/context/AbilityContext";
import {FormMixin} from "@/components/base/FormMixin";
import AlertError2 from "@/components/UI/Bootstrap/Alert/AlertError2.vue";
import BaseDeleteButton from "@/components/UI/Bootstrap/BaseDeleteButton.vue";
import {ProductFiltersRestService} from "@/services/rest/product-filters/ProductFiltersRestService";
import BaseEditButton from "@/components/UI/Bootstrap/BaseEditButton.vue";

export default defineComponent({
  name: "ProductFiltersOverview",
  mixins: [FormMixin],
  components: {BaseEditButton, BaseDeleteButton, AlertError2, BaseTitle, CatalogBuildStatus},
  data() {
    return {
      productFilters: [] as ProductFilterOverviewRestDto[],
    };
  },
  mounted() {
    this.reloadContent();
  },
  computed: {
    AbilityContext() {
      return AbilityContext
    }
  },
  methods: {
    async doDeleteItemWithKey(filterCode: string): Promise<void> {
      await ProductFiltersRestService.getInstance().deleteProductFilter(filterCode);
    },
    async doReload(): Promise<void> {
      this.productFilters = await ProductFiltersRestService.getInstance().findProductFilters(true);
    }
  }
});
